<div class="container login_container">
  <span class="title_Welcome" i18n>Bienvenue sur</span>
  <div class="row">
    <div class="col-10">
      <span class="title_HelvetiaNet">L'AppliCom</span>
    </div>
  </div>
  <form [formGroup]="form" (ngSubmit)="submitForm()" class="form-container">
    <div class="form-group">
      <mat-form-field [formGroup]="form">
        <mat-label i18n>Identifiant</mat-label>
        <input matInput type="text" formControlName="identifiant" maxlength="100"/>
      </mat-form-field>
    </div>
    <div class="form-group">
      <mat-form-field [formGroup]="form">
        <mat-label i18n>Mot de passe</mat-label>
        <input matInput type="password" formControlName="password" maxlength="100"/>
      </mat-form-field>
    </div>
    <hv-loader-button
      color="primary"
      buttonType="submit"
      class="login-button"
      modificationText="Connecté"
      [disabled]="form.invalid"
      i18n-text
      i18n-modificationText
      >Se Connecter
    </hv-loader-button>
  </form>
</div>
